var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg47(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#00a193;}.cls-1{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.34,17.31H1.08V10.82A4.33,4.33,0,0,1,5.41,6.49H53a4.32,4.32,0,0,1,4.32,4.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.57,
    y: 22.72,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.48,
    y: 22.72,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.38,
    y: 22.72,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.28,
    y: 22.72,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.57,
    y: 34.62,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.48,
    y: 34.62,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.38,
    y: 34.62,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.28,
    y: 34.62,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.57,
    y: 46.52,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.48,
    y: 46.52,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.38,
    y: 46.52,
    width: 6.49,
    height: 6.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.43,41.23V10.82A5.42,5.42,0,0,0,53,5.41H50.85V3.25a3.25,3.25,0,1,0-6.49,0V5.41H39V3.25a3.25,3.25,0,1,0-6.49,0V5.41H26V3.25a3.25,3.25,0,1,0-6.49,0V5.41H14.07V3.25a3.25,3.25,0,0,0-6.5,0V5.41H5.41A5.42,5.42,0,0,0,0,10.82V54.1a5.42,5.42,0,0,0,5.41,5.41H41.79A13,13,0,1,0,58.43,41.23Zm-11.91-38a1.09,1.09,0,1,1,2.17,0V9.74a1.09,1.09,0,0,1-2.17,0Zm-11.9,0a1.09,1.09,0,1,1,2.17,0V9.74a1.09,1.09,0,0,1-2.17,0Zm-13,0a1.08,1.08,0,1,1,2.16,0V9.74a1.08,1.08,0,0,1-2.16,0Zm-11.9,0a1.08,1.08,0,1,1,2.16,0V9.74a1.08,1.08,0,1,1-2.16,0ZM5.41,7.57H7.57V9.74a3.25,3.25,0,0,0,6.5,0V7.57h5.41V9.74a3.25,3.25,0,0,0,6.49,0V7.57h6.49V9.74a3.25,3.25,0,0,0,6.49,0V7.57h5.41V9.74a3.25,3.25,0,0,0,6.49,0V7.57H53a3.25,3.25,0,0,1,3.24,3.25v5.41H2.16V10.82A3.26,3.26,0,0,1,5.41,7.57Zm0,49.77A3.25,3.25,0,0,1,2.16,54.1V18.39h54.1V40.46a12.2,12.2,0,0,0-5.41-.23V34.62a1.08,1.08,0,0,0-1.08-1.08H43.28a1.08,1.08,0,0,0-1.08,1.08v6.49a1.08,1.08,0,0,0,1.08,1.09h2.57a12.89,12.89,0,0,0-5.06,15.14ZM48.69,40H44.36V35.7h4.33ZM53,63.84A10.82,10.82,0,1,1,63.84,53,10.83,10.83,0,0,1,53,63.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.1,51.15V44.36H51.93v6.79A2.18,2.18,0,0,0,50.85,53c0,.11,0,.21,0,.32l-4,3.16,1.35,1.69L52.23,55a2.31,2.31,0,0,0,.79.15,2.16,2.16,0,0,0,1.08-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.07,21.64H7.57a1.08,1.08,0,0,0-1.08,1.08v6.49A1.09,1.09,0,0,0,7.57,30.3h6.5a1.09,1.09,0,0,0,1.08-1.09V22.72a1.08,1.08,0,0,0-1.08-1.08ZM13,28.13H8.66V23.8H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26,21.64H19.48a1.08,1.08,0,0,0-1.09,1.08v6.49a1.09,1.09,0,0,0,1.09,1.09H26a1.08,1.08,0,0,0,1.08-1.09V22.72A1.08,1.08,0,0,0,26,21.64Zm-1.08,6.49H20.56V23.8h4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.87,21.64H31.38a1.08,1.08,0,0,0-1.08,1.08v6.49a1.08,1.08,0,0,0,1.08,1.09h6.49A1.08,1.08,0,0,0,39,29.21V22.72a1.08,1.08,0,0,0-1.08-1.08Zm-1.08,6.49H32.46V23.8h4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.28,30.3h6.49a1.08,1.08,0,0,0,1.08-1.09V22.72a1.08,1.08,0,0,0-1.08-1.08H43.28a1.08,1.08,0,0,0-1.08,1.08v6.49a1.08,1.08,0,0,0,1.08,1.09Zm1.08-6.5h4.33v4.33H44.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.07,33.54H7.57a1.08,1.08,0,0,0-1.08,1.08v6.49A1.09,1.09,0,0,0,7.57,42.2h6.5a1.09,1.09,0,0,0,1.08-1.09V34.62a1.08,1.08,0,0,0-1.08-1.08ZM13,40H8.66V35.7H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26,33.54H19.48a1.08,1.08,0,0,0-1.09,1.08v6.49a1.09,1.09,0,0,0,1.09,1.09H26a1.08,1.08,0,0,0,1.08-1.09V34.62A1.08,1.08,0,0,0,26,33.54ZM24.89,40H20.56V35.7h4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.87,33.54H31.38a1.08,1.08,0,0,0-1.08,1.08v6.49a1.08,1.08,0,0,0,1.08,1.09h6.49A1.08,1.08,0,0,0,39,41.11V34.62a1.08,1.08,0,0,0-1.08-1.08ZM36.79,40H32.46V35.7h4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.07,45.44H7.57a1.09,1.09,0,0,0-1.08,1.08V53A1.09,1.09,0,0,0,7.57,54.1h6.5A1.09,1.09,0,0,0,15.15,53v-6.5a1.09,1.09,0,0,0-1.08-1.08ZM13,51.93H8.66V47.61H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26,45.44H19.48a1.09,1.09,0,0,0-1.09,1.08V53a1.09,1.09,0,0,0,1.09,1.08H26A1.08,1.08,0,0,0,27.05,53v-6.5A1.08,1.08,0,0,0,26,45.44Zm-1.08,6.49H20.56V47.61h4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.87,45.44H31.38a1.08,1.08,0,0,0-1.08,1.08V53a1.08,1.08,0,0,0,1.08,1.08h6.49A1.08,1.08,0,0,0,39,53v-6.5a1.08,1.08,0,0,0-1.08-1.08Zm-1.08,6.49H32.46V47.61h4.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg47);
export default __webpack_public_path__ + "static/media/47.a589b122bf17137c602170cb442cb65f.svg";
export { ForwardRef as ReactComponent };